import React from "react";
import { FlexRowBetween, RespFont } from "../Style";

const FilterBar = ({
  data,
  setProperty,
  property,
  color = "#7b96c4",
  padding = false,
}) => {
  let widthS = window.innerWidth;

  return (
    <FlexRowBetween
      style={{
        width: "min-content",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        borderRadius: "999px",
        padding: widthS > 768 ? "6px" : "4px",
        fontWeight: "700",
        overflowX: "auto",
        margin: "0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        background: "rgba(255,255,255,0.5)",
      }}
    >
      {data.map((item, index) => {
        return (
          <RespFont
            key={index}
            psize={"12px"}
            csize={"14px"}
            onClick={() => setProperty(item.name)}
            style={{
              padding: padding
                ? padding
                : widthS > 768
                  ? "7px 12px"
                  : "3.5px 6px",
              cursor: "pointer",
              width: "max-content",
              background: property === item.name ? color : "transparent",
              transition: "all 0.25s ease",
              color: property === item.name ? "#fff" : "#3a3c3f",
              borderRadius: "999px",
            }}
          >
            {item.name}
          </RespFont>
        );
      })}
    </FlexRowBetween>
  );
};
export default FilterBar;
